<template>
    
    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
  </template>
  
  
  <script>
  import auth from "../../../api/auth";
  import axios from "axios";
  
  export default {
  
   
    beforeMount: beforeMount,
    methods: {
      SatinAl() {


if (this.sozlesmeOnay == true) {
       
   

    this.UrunKayit.Tarih = getDateNow()
    this.UrunKayit.OdemeOnay = true
    this.UrunKayit.Aciklama = 'Stripe'

    var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == this.musteriidurun)

    this.UrunKayit.UlkeID = manageload.AnaSirketInfo[index].UlkeID

    var params = this.UrunKayit

    this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        if (response.body.Status == true) {

            if (response.body.SaveID != null && response.body.SaveID != '') {

                this.MusteriUrun.MusteriID = this.musteriidurun
               
                this.MusteriUrun.OdemeBilgi.ID = response.body.SaveID
                this.MusteriUrun.OdemeBilgi.OdemeTip = this.UrunKayit.OdemeTip
                this.MusteriUrun.OdemeBilgi.OdemeOnay = true
                this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID

                if (this.pakettipi == 2) {
                    this.MusteriUrun.KontorAdet = this.kontorAdet
                    this.MusteriUrun.KalanKontorAdet = this.kontorAdet
                    this.MusteriUrun.BaslangicTarih = getDateNow()
                    this.MusteriUrun.BitisTarihi = getDateNow()
                } else {
                    this.MusteriUrun.KontorAdet = 0
                    this.MusteriUrun.KalanKontorAdet = 0
                    this.MusteriUrun.BaslangicTarih = null
                    this.MusteriUrun.BitisTarihi = null
                }
                var params = this.MusteriUrun


                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerSave',
                    params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                     this.text1 = this.$t(response.body.ResponseMessage)
                     this.snackbar = true

                    if (response.body.Status == true) {
                        localStorage.removeItem('po');
                        setTimeout(function () {
                            var url = '#/anasirket'
                            window.open(url, '_self')
                        }.bind(this), 4000)
                    }


                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                        this.snackbar = true
                    }
                })


            } else {
                this.text1 =
                    'Ödeme kayıt işlemi tamamlandı. Ürün kullanıcınıza tanıtılamadı. Lüfen destek ekibine ulaşınız.'
                this.snackbar = true
            }

        } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

        }


    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
        }
    })
} else {
    this.text1 = this.$t('You-need-approve-contract')
    this.snackbar = true
}
},
    },
    data() {
      return {
        snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1:'',
        musteriidurun:0,
        sozlesmeOnay:true,
        kontorAdet:0,
       MusteriUrun: {
                ID: null,
                MusteriID: null,
                PaketBilgi: {
                    PaketID: null,
                    PaketTip: null,
                },
                OdemeBilgi: {
                    ID: null,
                    OdemeTip: 0,
                    OdemeOnay: false
                },
                BaslangicTarih: null,
                BitisTarihi: null,
                KontorAdet: 0,
                KalanKontorAdet: 0,
                BiletAdet: 0,
                FaturaAdet: 0,
                CariAdet: 0,
                IadeAdet: 0,
                VoidAdet: 0,
                CoperAdet: 0,
                CoperIptalAdet: 0,
                VizeAdet: 0,
            },
            UrunKayit: {
                ID: null,
                Aciklama: null,
                OdemeTip: '1', // 0 Havale 1 Kredi
                OdemeOnay: true,
                Tarih: null,
                Tutar: 0,
                Banka: null,
                TaksitAdet: null,
                VadeFarki: null,
                VadeTarihi: null,
                CariKod: null,
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: null,
                IslemID: null,
                GuID: null,
                SiparisID: null,
                DekontID: null,
                UlkeID: null,
            },
      };
    },
  };
  function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }
  function beforeMount() {
    var paket = JSON.parse(window.localStorage.getItem('po'));
    this.musteriidurun=paket.musteriid;
    this.UrunKayit.Tutar=paket.Tutar;
    this.MusteriUrun.MusteriID=paket.musteriid;
    this.MusteriUrun.PaketBilgi.PaketID=paket.paketid;
    this.MusteriUrun.PaketBilgi.PaketTip=paket.pakettip;
    this.kontorAdet=paket.kontorAdet;
    this.SatinAl();

    // var url = '#/account/urunler/id?sirket=null'
    // window.open(url, '_self')

    

  }
 
  </script>